import { defineStore } from 'pinia';
import { ref } from 'vue';
import carListingsAPI from '@/api/carListings';
import type { CarListing } from '@/types/CarListing';

export const useCarListingsStore = defineStore('carListings', () => {
  const carListings = ref<CarListing[]>([]);
  
  const fetchCarListings = async (params: any): Promise<{ data: CarListing[]; total: number }> => {
    try {
      
      const response = await carListingsAPI.getCarListings(params);
      const data: CarListing[] = response.data.data;
      const total = response.data.meta.total;
      carListings.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching car listings:', error);
      throw error;
    }
  };

  const fetchCarListingById = async (id: number) => {
    try {
      const response = await carListingsAPI.getCarListingById(id);
      return response.data.data as CarListing;
    } catch (error) {
      console.error(`Error fetching car listing with ID ${id}:`, error);
    }
  };

  const createCarListing = async (carListingData: Partial<CarListing>) => {
    try {
      const response = await carListingsAPI.createCarListing(carListingData);
      carListings.value.push(response.data.data as CarListing);
      return response.data;
    } catch (error) {
      console.error('Error creating car listing:', error);
    }
  };

  const updateCarListing = async (id: number, carListingData: Partial<CarListing>) => {
    try {
      const response = await carListingsAPI.updateCarListing(id, carListingData);
      const updated = response.data.data as CarListing;
      const index = carListings.value.findIndex((listing) => listing.id === id);
      if (index !== -1) {
        carListings.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating car listing with ID ${id}:`, error);
    }
  };

  const deleteCarListing = async (id: number) => {
    try {
      await carListingsAPI.deleteCarListing(id);
      carListings.value = carListings.value.filter((listing) => listing.id !== id);
    } catch (error) {
      console.error(`Error deleting car listing with ID ${id}:`, error);
    }
  };

  return {
    carListings,
    fetchCarListings,
    fetchCarListingById,
    createCarListing,
    updateCarListing,
    deleteCarListing,
  };
});
